// extracted by mini-css-extract-plugin
export var list = "socials-module--list--39BD8";
export var black = "socials-module--black--ZqcLQ";
export var item = "socials-module--item--2VeyH";
export var link = "socials-module--link--ol3U3";